<template>
  <v-app id="inspire" class="grey lighten-3">
   <Navbar/>
   <v-main>
     <v-flex>
         <v-container
        fluid
      >
        <v-layout px-5  row class="mt-1">
          <v-flex xs4 md9 dense>
            <div class="subtitle" style=" font-size: 0.92em;">Dashboard</div>
          </v-flex>
          <v-flex class="text-right" xs8 md3 >
            <v-spacer/>
             <v-breadcrumbs class="pa-0" :items="crumbItems" id="crumbs">
              <template v-slot:item="{item}">
                <v-breadcrumbs-item :href="item.href" :disabled="item.disabled" @click="breadCrumbClick(item)" style=" font-size: 0.92em;">
                  {{item.text}}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
          </v-flex>
        </v-layout>
        <Header/>
        <ManageReportCategories/>
      </v-container>
     </v-flex>
   </v-main>
  </v-app>
</template>

<script>
import Navbar from '@/components/NavbarComponent'
import Header from '@/components/HeaderComponent'
import ManageReportCategories from '@/components/ManageReportCategories'
export default {
  data: () => {
    return {
      crumbItems: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '#',
          route: '/home'
        },
        {
          text: 'Manage Permissions',
          disabled: false,
          href: '#',
          route: '/manageReportCategories'
        }
      ]
    }
  },
  components: {
    Navbar,
    Header,
    ManageReportCategories
  },
  mounted: [
  ],
  methods: {
    breadCrumbClick (item) {
      this.$router.push(item.route).catch(() => {
        window.location.reload()
      })
    }
  }
}
</script>

<style scoped>
#crumbs{
  align-content: right;
  justify-content: right;
}
</style>
